namespace $ {
	export class $lyumih_test extends $mol_page {
		
		/**
		 * ```tree
		 * title \Подключение Яндекс Метрики и Гугл аналитики
		 * ```
		 */
		title() {
			return "Подключение Яндекс Метрики и Гугл аналитики"
		}
	}
	
}

